import React from "react";

import { Box, ScrollArea, Table, Text, createStyles } from "@mantine/core";

import { useState } from "react";
import { useSelector } from "react-redux";
import NoteTableRow from "../NoteTableRow";
import TableLoader from "../TableLoader";
import NoNoteDataSvg from "../Svgs/NoNoteDataSvg";
import { NewAddButton } from "../AddButton/NewAddButton";
import { NotetTypeSvg } from "../Svgs/NotetTypeSvg";
import { getAllStaff } from "../../services/staff";

const useStyles = createStyles((theme) => ({
  header: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    borderRadius: "16px",
    transition: "box-shadow 150ms ease",
    "& th": {
      backgroundColor: "var(--app-surface)",
      color: "var(--app-text) !important",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
    },
  },

  scrolled: {
    boxShadow: theme.shadows.sm,
  },
  noData: {
    padding: "2rem",
    textAlign: "center",
    height: "100dvh",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  scrollArea: {
    backgroundColor: "var(--app-surface)",
    borderRadius: "8px",
    border: "1px solid var(--app-border)",
  },
  loading:{
    height: "50dvh",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }
}));

const NoteTable = ({
  openModal,
  openViewModal,
  setView,
  userId,
  // loading,
  sortField,
  sortOrder,
  currentPage,
  dateRange,
  activeFilters,
  setOpen,
}) => {
  const { notes, notePageloading } = useSelector((state) => state?.note);
  const { classes, cx } = useStyles();
  const [scrolled, setScrolled] = useState(false);

  return (
    <ScrollArea
      onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
      className={classes.scrollArea}
    >
      {notePageloading ? (
        <Box className={classes.loading}>
        <TableLoader />
        </Box>
      ) : notes?.notes?.length > 0 ? (
        <Table
          fontSize={"sm"}
          highlightOnHover
          enableStickyHeader
          verticalSpacing={"md"}
          sx={{ fontFamily: "Inter" }}
        >
          <thead
            className={cx(classes.header, { [classes.scrolled]: scrolled })}
          >
            <tr>
              <th style={{ minWidth: "140px" }}>Id</th>
              <th style={{ minWidth: "200px" }}>Note Type</th>
              <th style={{ minWidth: "180px" }}>Staff Name</th>
              <th style={{ minWidth: "140px" }}>Date</th>
              <th style={{ minWidth: "120px" }}>Time</th>
              <th style={{ minWidth: "140px" }}>Facility Name</th>
              <th style={{ minWidth: "140px" }}>Client Name</th>
              <th style={{ minWidth: "140px" }}>Description</th>
              {/* <th style={{ minWidth: "140px" }}>Medication</th>
              <th style={{ minWidth: "140px" }}>Reason</th> */}
              <th style={{ minWidth: "170px" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {notes?.notes.map((row, i) => (
              <NoteTableRow
                key={i}
                index={i}
                row={row}
                userId={userId}
                open={openModal}
                openViewModal={openViewModal}
                setView={setView}
                sortField={sortField}
                sortOrder={sortOrder}
                currentPage={currentPage}
                dateRange={dateRange}
                activeFilters={activeFilters}
              />
            ))}
          </tbody>
        </Table>
      ) : (
        <Box className={classes.noData}>
          <NoNoteDataSvg />
          <Text fw={600} size="xl" mb="md" c={"var(--app-text)"} ff={"inter"}>
            No Notes
          </Text>
          <Text fw={400} size="md" mb="md" c={"var(--app-text-muted)"}>
            {" "}
            Please click ‘Add Note’ to start adding notes now!
          </Text>
          <NewAddButton
            title="Add Note"
            onClick={() => {
              getAllStaff("all");
              setOpen(true);
            }}
            color="var(--app-primary)"
            textColor="var(--app-on-primary)"
            variant="filled"
            borderColor="none"
          />
        </Box>
      )}
    </ScrollArea>
  );
};

export default NoteTable;
